/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SystemEntity {
  Organisation = 'Organisation',
  Person = 'Person',
  User = 'User',
  Team = 'Team',
  Appointment = 'Appointment',
  Task = 'Task',
  ActivityParty = 'ActivityParty',
  ElectronicAddress = 'ElectronicAddress',
  PhoneAddress = 'PhoneAddress',
  PostalAddress = 'PostalAddress',
  PartyRole = 'PartyRole',
  PartyRoleAccess = 'PartyRoleAccess',
  Relationship = 'Relationship',
  Email = 'Email',
  PhoneCall = 'PhoneCall',
  WebHook = 'WebHook',
  Construct = 'Construct',
  Process = 'Process',
  WorkItem = 'WorkItem',
  SocialAddress = 'SocialAddress',
  Product = 'Product',
  ClientProductRelationship = 'ClientProductRelationship',
  ClientProduct = 'ClientProduct',
  ProductGroup = 'ProductGroup',
  Mandate = 'Mandate',
  Objective = 'Objective',
  Tag = 'Tag',
  Note = 'Note',
  Channel = 'Channel',
  DocumentAssociation = 'DocumentAssociation',
  Client = 'Client',
  Intermediary = 'Intermediary',
  Salutation = 'Salutation',
  AmlReport = 'AmlReport',
  FeeStructure = 'FeeStructure',
  TimeBooking = 'TimeBooking',
  Notification = 'Notification',
  AmlRisk = 'AmlRisk',
  DataLock = 'DataLock',
  RiskLevel = 'RiskLevel',
  Comment = 'Comment',
  Nudge = 'Nudge',
  NudgeLog = 'NudgeLog',
  FeedNudge = 'FeedNudge',
  Reminder = 'Reminder',
  Adviser = 'Adviser',
  Goal = 'Goal',
  Article = 'Article',
  Letter = 'Letter',
  InvestmentAccount = 'InvestmentAccount',
  BankAccount = 'BankAccount',
  UserView = 'UserView',
  Opportunity = 'Opportunity',
  MailingInstruction = 'MailingInstruction',
  Benchmark = 'Benchmark',
  Case = 'Case',
  AppStatus = 'AppStatus',
  LendingAccount = 'LendingAccount',
  InsuranceAccount = 'InsuranceAccount',
  PotentialDuplicate = 'PotentialDuplicate',
  Engagement = 'Engagement',
  Message = 'Message',
  ArticleDistribution = 'ArticleDistribution',
  DocumentTemplate = 'DocumentTemplate',
  QiStatus = 'QiStatus',
  QueueItem = 'QueueItem',
  CaseTeamMember = 'CaseTeamMember',
  List = 'List',
  Answer = 'Answer',
  Document = 'Document',
  FileIndex = 'FileIndex',
  TeamMember = 'TeamMember',
  DocumentRequirementType = 'DocumentRequirementType',
  DocumentRequirement = 'DocumentRequirement',
  Import = 'Import',
  ExternalBankAccount = 'ExternalBankAccount',
  ExternalBankAccountAssociation = 'ExternalBankAccountAssociation',
  OpportunityProduct = 'OpportunityProduct',
  CountryAssociation = 'CountryAssociation',
  NationalIdentifier = 'NationalIdentifier',
  OpportunityTeamMember = 'OpportunityTeamMember',
  Region = 'Region',
  Portfolio = 'Portfolio',
  Lead = 'Lead',
  ClientProductAccess = 'ClientProductAccess',
  Export = 'Export',
  EdsMessageBatch = 'EdsMessageBatch',
  EdsMessage = 'EdsMessage',
  MandateGroup = 'MandateGroup',
  Project = 'Project',
  DocumentType = 'DocumentType',
  History = 'History',
  Campaign = 'Campaign',
  CampaignResponse = 'CampaignResponse',
  UserLogin = 'UserLogin',
  ViewTile = 'ViewTile',
  ExternalUser = 'ExternalUser',
  Session = 'Session',
  IdentityCheck = 'IdentityCheck',
  CreditAccount = 'CreditAccount',
  UserDashboard = 'UserDashboard',
  ImportLog = 'ImportLog',
  Envelope = 'Envelope',
  Signatory = 'Signatory',
  IdentityMap = 'IdentityMap',
  ProductProvider = 'ProductProvider',
  WealthManagementAccount = 'WealthManagementAccount',
  ProtectionAccount = 'ProtectionAccount',
  FinancialRecord = 'FinancialRecord',
  FinancialRecordSubType = 'FinancialRecordSubType',
  ProductFinancialLink = 'ProductFinancialLink',
  PendingChange = 'PendingChange',
  PensionAccount = 'PensionAccount',
  ListMember = 'ListMember',
  ExternalTask = 'ExternalTask',
  Block = 'Block',
  Event = 'Event',
  EventParticipation = 'EventParticipation',
  ElectronicBankingAddress = 'ElectronicBankingAddress',
  PartySystemConnection = 'PartySystemConnection',
  ServiceType = 'ServiceType',
  EmploymentHistory = 'EmploymentHistory',
  InsiderHistory = 'InsiderHistory',
  KycReport = 'KycReport',
  StockBrokingAccount = 'StockBrokingAccount',
  WebHookLog = 'WebHookLog',
  ClientProductAllocation = 'ClientProductAllocation',
  ProductLine = 'ProductLine',
  ProductLineAssociation = 'ProductLineAssociation',
  Unit = 'Unit',
  UnitGroup = 'UnitGroup',
  ProjectTemplate = 'ProjectTemplate',
  ClientProductGroup = 'ClientProductGroup',
  ClientProductAssociation = 'ClientProductAssociation',
  ProjectTemplateTask = 'ProjectTemplateTask',
  ReportRequest = 'ReportRequest',
  ActivityFile = 'ActivityFile',
  GoalType = 'GoalType',
  ProductCriteria = 'ProductCriteria',
  ProductCriteriaType = 'ProductCriteriaType',
  ProductRecommendation = 'ProductRecommendation',
  ProductFee = 'ProductFee',
  ClientProductFee = 'ClientProductFee',
  RiskProfileQuestion = 'RiskProfileQuestion',
  RiskProfileAnswer = 'RiskProfileAnswer',
  NudgeType = 'NudgeType',
  ProductCategory = 'ProductCategory',
  ListType = 'ListType',
  Transaction = 'Transaction',
  TransactionEvidence = 'TransactionEvidence',
  IdentityCheckResult = 'IdentityCheckResult',
  AppendixEntry = 'AppendixEntry',
  AppendixSchema = 'AppendixSchema',
  AppendixLayout = 'AppendixLayout',
  AppendixCalculation = 'AppendixCalculation',
  AppendixApp = 'AppendixApp',
  ProtectedFieldGroup = 'ProtectedFieldGroup',
  FormData = 'FormData',
  RecentRecord = 'RecentRecord',
  Favourite = 'Favourite',
  DmsDocument = 'DmsDocument',
  Workflow = 'Workflow',
  WorkflowLog = 'WorkflowLog',
  ScheduledJob = 'ScheduledJob',
  Job = 'Job',
  SystemLog = 'SystemLog',
  AuditEvent = 'AuditEvent',
  Country = 'Country',
  Currency = 'Currency',
  ProductType = 'ProductType',
  RoleType = 'RoleType',
  RoleSubType = 'RoleSubType',
  CaseType = 'CaseType',
  KanbanStage = 'KanbanStage',
  Report = 'Report',
  AnswerType = 'AnswerType',
  ProcessType = 'ProcessType',
  KanbanType = 'KanbanType',
  QueueStatus = 'QueueStatus',
  GeneratedDocument = 'GeneratedDocument',
  Feed = 'Feed',
  EntityMetadata = 'EntityMetadata',
  EntityAttributeMetadata = 'EntityAttributeMetadata',
  FormMetadata = 'FormMetadata',
  FormFieldMetadata = 'FormFieldMetadata',
  FormFunctionMetadata = 'FormFunctionMetadata',
  ContactPoint = 'ContactPoint',
  Activity = 'Activity',
  Party = 'Party'
}
